<template>
  <div class="flex px-4">
    <StepItem
      v-for="(step, i) in steps"
      :key="i"
      :index="i + 1"
      :label="step.label"
      :description="step.description"
      :selected="currentStep === i + 1"
      @click="stepMove(i + 1)"
      :active="Math.abs(i + 1 - currentStep) === 1"
      :icon="icon"
      :last="i === steps.length - 1"
    />
  </div>
</template>

<script setup>
import StepItem from '@/components/atoms/StepItem.vue'

const emit = defineEmits(['moveBack', 'moveForward', 'addStep'])
const steps = defineModel()
const currentStep = defineModel('currentStep', {type: Number, default: 1})
const props = defineProps({icon: Boolean})
const stepMove = (step) => {
  let difference = step - currentStep.value
  if (step < 1 || step > steps.length) {
    console.error('Invalid step:', step)
    return
  } else if (Math.abs(difference)>1  ) {
    console.error('Step too far:', step)
    return
  }
  console.log('Step moved to:', step)
  currentStep.value = step
  if (difference > 0) {
    emit('moveForward')
    if (props.icon && step === steps.value.length) {
      console.log('Icon mode enabled')
      steps.value.push(steps.value[step-1])
      steps.value[step-1] = steps.value[step - 2]
      emit('addStep')
    }
  } else if (difference < 0) {
    emit('moveBack')
  }
}
</script>